import styled, { keyframes } from 'styled-components';
import { ReactComponent as Spinner } from './spinner.svg';
export {
  default as ArrowDownUrl,
  ReactComponent as ArrowDownIcon,
} from './arrow-down.svg';
export {
  default as ArrowLeftUrl,
  ReactComponent as ArrowLeftIcon,
} from './arrow-left.svg';
export {
  default as ArrowRightUrl,
  ReactComponent as ArrowRightIcon,
} from './arrow-right.svg';
export {
  default as ArrowUpUrl,
  ReactComponent as ArrowUpIcon,
} from './arrow-up.svg';
export {
  default as BookmarkUrl,
  ReactComponent as BookmarkIcon,
} from './bookmark.svg';
export {
  default as BookmarkFilledUrl,
  ReactComponent as BookmarkFilledIcon,
} from './bookmark-filled.svg';
export {
  default as BoxConditionUrl,
  ReactComponent as BoxConditionIcon,
} from './box-condition.svg';
export { default as BellUrl, ReactComponent as BellIcon } from './bell.svg';
export {
  default as CameraUrl,
  ReactComponent as CameraIcon,
} from './camera.svg';
export { default as CaretUrl, ReactComponent as CaretIcon } from './caret.svg';
export { default as CartUrl, ReactComponent as CartIcon } from './cart.svg';
export {
  default as CheckCircleFilledUrl,
  ReactComponent as CheckCircleFilledIcon,
} from './check-circle-filled.svg';

export {
  default as CrossCircleFilled,
  ReactComponent as CrossCircleFilledIcon,
} from './cross-circle-filled.svg';

export {
  default as MinusCircleFilled,
  ReactComponent as MinusCircleFilledIcon,
} from './minus-circle-filled.svg';

export {
  default as CheckCircleUrl,
  ReactComponent as CheckCircleIcon,
} from './check-circle.svg';
export { default as CheckUrl, ReactComponent as CheckIcon } from './check.svg';
export {
  default as ChevronDownUrl,
  ReactComponent as ChevronDownIcon,
} from './chevron-down.svg';
export {
  default as ChevronLeftUrl,
  ReactComponent as ChevronLeftIcon,
} from './chevron-left.svg';
export {
  default as ChevronRightUrl,
  ReactComponent as ChevronRightIcon,
} from './chevron-right.svg';
export {
  default as ChevronRightLightUrl,
  ReactComponent as ChevronRightLightIcon,
} from './chevron-right-light.svg';
export {
  default as ChevronUpUrl,
  ReactComponent as ChevronUpIcon,
} from './chevron-up.svg';
export { default as ClockUrl, ReactComponent as ClockIcon } from './clock.svg';
export {
  default as CreditCardUrl,
  ReactComponent as CreditCardIcon,
} from './credit-card.svg';
export { default as CrossUrl, ReactComponent as CrossIcon } from './cross.svg';
export {
  default as DeliveryUrl,
  ReactComponent as DeliveryIcon,
} from './delivery.svg';
export {
  default as DollarSignPiUrl,
  ReactComponent as DollarSignPicket,
} from './dollar-sign-picket.svg';
export {
  default as DollarSignUrl,
  ReactComponent as DollarSignIcon,
} from './dollar-sign.svg';
export { default as EditUrl, ReactComponent as EditIcon } from './edit.svg';
export {
  default as EnvelopeUrl,
  ReactComponent as EnvelopeIcon,
} from './envelope.svg';
export {
  default as ExclamationTriangleUrl,
  ReactComponent as ExclamationTriangleIcon,
} from './exclamation-triangle.svg';
export {
  default as ExpandedListUrl,
  ReactComponent as ExpandedListIcon,
} from './expanded-list.svg';
export { default as EyeUrl, ReactComponent as EyeIcon } from './eye.svg';
export { default as FileUrl, ReactComponent as FileIcon } from './file.svg';
export {
  default as FilterUrl,
  ReactComponent as FilterIcon,
} from './filter.svg';
export { default as GavelUrl, ReactComponent as GavelIcon } from './gavel.svg';
export { default as GiftUrl, ReactComponent as GiftIcon } from './gift.svg';
export {
  default as HeartFilledUrl,
  ReactComponent as HeartFilledIcon,
} from './heart-filled.svg';
export { default as HeartUrl, ReactComponent as HeartIcon } from './heart.svg';
export {
  default as InfoCircleUrl,
  ReactComponent as InfoCircleIcon,
} from './info-circle.svg';
export { default as LogoUrl, ReactComponent as LogoIcon } from './logo.svg';
export {
  default as MagnifyingGlassUrl,
  ReactComponent as MagnifyingGlassIcon,
} from './magnifying-glass.svg';
export {
  default as MapMarkerUrl,
  ReactComponent as MapMarkerIcon,
} from './map-marker.svg';
export {
  default as MedalGold,
  ReactComponent as MedalGoldIcon,
} from './medal-gold.svg';
export {
  default as MegaphoneUrl,
  ReactComponent as MegaphoneIcon,
} from './megaphone.svg';
export {
  default as HamburgerMenu,
  ReactComponent as HamburgerMenuIcon,
} from './hamburger-menu.svg';
export {
  default as HamburgerMenuLeft,
  ReactComponent as HamburgerMenuLeftIcon,
} from './hamburger-menu-left.svg';
export {
  default as HamburgerMenuRight,
  ReactComponent as HamburgerMenuRightIcon,
} from './hamburger-menu-right.svg';
export { default as MinusUrl, ReactComponent as MinusIcon } from './minus.svg';
export {
  default as PaypalUrl,
  ReactComponent as PaypalIcon,
} from './paypal.svg';
export { default as PhoneUrl, ReactComponent as PhoneIcon } from './phone.svg';
export { default as PlusUrl, ReactComponent as PlusIcon } from './plus.svg';
export {
  default as ShieldCheckUrl,
  ReactComponent as ShieldCheckIcon,
} from './shield-check.svg';
export { default as TagUrl, ReactComponent as TagIcon } from './tag.svg';
export {
  default as TimesCircleUrl,
  ReactComponent as TimesCircleIcon,
} from './times-circle.svg';
export { default as TruckUrl, ReactComponent as TruckIcon } from './truck.svg';
export { default as UserUrl, ReactComponent as UserIcon } from './user.svg';
export {
  default as ItemsPageUrl,
  ReactComponent as ItemsPageIcon,
} from './items-page.svg';
export { default as Star, ReactComponent as StarIcon } from './star.svg';
export {
  default as HalfStar,
  ReactComponent as HalfStarIcon,
} from './half-star.svg';
export {
  default as GooglePlay,
  ReactComponent as GooglePlayIcon,
} from './google-play.svg';
export {
  default as AppStore,
  ReactComponent as AppStoreIcon,
} from './app-store.svg';
export { default as Amex, ReactComponent as AmexIcon } from './amex.svg';
export {
  default as DinersClub,
  ReactComponent as DinersClubIcon,
} from './diners-club.svg';
export {
  default as Facebook,
  ReactComponent as FacebookIcon,
} from './facebook.svg';
export {
  default as Instagram,
  ReactComponent as InstagramIcon,
} from './instagram.svg';
export {
  default as Linkedin,
  ReactComponent as LinkedinIcon,
} from './linkedin.svg';
export {
  default as Mastercard,
  ReactComponent as MastercardIcon,
} from './mastercard.svg';
export {
  default as PaypalLogo,
  ReactComponent as PaypalLogoIcon,
} from './paypal-logo.svg';
export { default as Tiktok, ReactComponent as TiktokIcon } from './tiktok.svg';
export {
  default as Twitter,
  ReactComponent as TwitterIcon,
} from './twitter.svg';
export { default as Visa, ReactComponent as VisaIcon } from './visa.svg';
export {
  default as Youtube,
  ReactComponent as YoutubeIcon,
} from './youtube.svg';
export {
  default as GraysApp,
  ReactComponent as GraysAppIcon,
} from './grays-app.svg';
export {
  default as WineTastingPanel,
  ReactComponent as WineTastingPanelIcon,
} from './wine-tasting-panel.svg';
export {
  default as WineCritic,
  ReactComponent as WineCriticIcon,
} from './wine-critic.svg';
export { default as Time, ReactComponent as TimeIcon } from './time.svg';
export {
  default as Support,
  ReactComponent as SupportIcon,
} from './support.svg';
export { default as Mail, ReactComponent as MailIcon } from './mail.svg';
export { default as Mobile, ReactComponent as MobileIcon } from './mobile.svg';

export * from './types';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(359deg);
    }
`;

export const SpinnerIcon = styled(Spinner)`
  animation: ${spin} 2s linear infinite;
`;
